import React from 'react'
import './my-challenges-list.styles.scss';
import PlayerRecordsList from '@/components/SHARED/player-records-list/player-records-list.component';

const MyChallengesList = ({
  gameData,
  playerData,
  gameElements
}) => {

  return (
    <div className='completed-challenges-list'>
      <PlayerRecordsList
        gameData={gameData}
        playerData={playerData}
        gameElements={gameElements}
        activityType='approvedChallenge'
        title='Completed Challenges'
        summaryLabel='Completed Challenges'
        summaryIcon='/images/icons/win.png'
        summaryCount={
          playerData?.challenges
            ? Object.values(playerData.challenges).filter(c => c.approved).length
            : 0
        }
        emptyText='No completed challenges yet...' />
    </div>
  )
}

export default MyChallengesList
